import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MappingService {
  getMappingIssuerData() {
    return [
      {
        arcId: 25,
        companyName: "meta",
        cik: "0001565717",
        irs: "610647538",
        fileNo: "037833100",
        yearEnd: "1231",
        affiliateName: "Armstrong Brian",
        issuerName: "Blue Acquisition Corp/Cayman",
        insiderName: "John",
        securityType: "10-K",
      },
      {
        arcId: 5,
        companyName: "facebook",
        cik: null,
        irs: null,
        fileNo: null,
        affiliateName: "mark Brian",
        yearEnd: null,
        issuerName: "Performant Healthcare Inc",
        insiderName: "John",
        securityType: "10-Q",
      },
      {
        arcId: 56,
        companyName: "meta",
        cik: null,
        irs: "610647538",
        fileNo: "037833100",
        yearEnd: "1231",
        affiliateName: "john ",
        issuerName: "MICROSTRATEGY Inc",
        insiderName: "John",
        securityType: "8-Q",
      },
      {
        arcId: 45,
        companyName: "facebook",
        cik: "0001565717",
        irs: null,
        fileNo: null,
        yearEnd: null,
        affiliateName: "edison ",
        issuerName: "StratCap Digital Infrastructure REIT, Inc.",
        insiderName: "John",
        securityType: "10-Q",
      },
      {
        arcId: 46,
        companyName: "facebook",
        cik: "0001565717",
        irs: null,
        fileNo: null,
        yearEnd: null,
        processed: true,
        affiliateName: "Armstrong ",
        issuerName: "BridgeBio Pharma, Inc.",
        insiderName: "John",
        securityType: "6-Q",
      },
    ];
  }
  getMappingInsiderData() {
    return [
      {
        araId: 33,
        affiliateName: "mark zuckerberg",
        cik: "0001548760",
      },
      {
        araId: 42,
        affiliateName: "Elon Musk",
        cik: "0001494730",
      },
      {
        araId: 43,
        affiliateName: "Elon Musk",
        cik: "0401494730",
        processed: true,
      },
    ];
  }
  getIssuers() {
    return Promise.resolve(this.getMappingIssuerData());
  }
  getInsiders() {
    return Promise.resolve(this.getMappingInsiderData());
  }
}
